var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDataset(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15 10.8333V4.5C15 3.39543 14.1046 2.5 13 2.5H8C6.34315 2.5 5 3.84315 5 5.5V12.5M15 10.8333H7C5.89543 10.8333 5 11.7288 5 12.8333V14.1667M15 10.8333V14.1667M5 14.1667H15M5 14.1667V15.5C5 16.6046 5.89543 17.5 7 17.5H15V14.1667M9.16667 5.83333H10.8333",
    stroke: "#DFD8D0",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDataset);
export default __webpack_public_path__ + "static/media/dataset.96228d32f23cbb9a9465614e30b493cf.svg";
export { ForwardRef as ReactComponent };